/**
 * Conversion de la saisie « montant validé manuellement » (euros) en centimes.
 * Extrait de ManualBpiValidationDialog pour rester testable isolément.
 *
 * 0 est une valeur VALIDE (dossier exonéré : le BPI est réputé réglé mais rien
 * n'est déduit du solde BED). Une saisie vide ou négative est invalide.
 */
// Plafond de saisie. Un acompte BPI plausible se compte en centaines d'euros
// (400 € typique, 800 € pour un double report) ; au-delà de 1 000 000 € c'est
// une faute de frappe. Sans borne, `1e9` déborde l'INTEGER de la colonne et
// remonte un 22003 illisible depuis PostgREST.
export const MANUAL_BPI_MAX_CENTS = 100_000_000;

export function parseEurosToCents(raw: string): number | null {
  // Clavier FR : la virgule décimale doit être acceptée.
  const normalized = raw.trim().replace(',', '.');
  if (normalized === '') return null;
  const value = Number(normalized);
  if (!Number.isFinite(value) || value < 0) return null;
  // Arrondi au centime : 400.005 € n'a pas de sens comptable.
  const cents = Math.round(value * 100);
  if (cents > MANUAL_BPI_MAX_CENTS) return null;
  return cents;
}

/** Montant en centimes -> saisie euros pré-remplie (correction d'une validation). */
export function formatCentsAsEurosInput(cents: number): string {
  return (cents / 100).toFixed(2);
}
